module.exports = "https://web-assets.ifttt.com/packs/media/docs/honeywell_auth-92b76c00.png";